export const UserPermissions = {
    SERVICE: 'service',
    IEVENTS: 'ievents',
    ISTORE: 'istore',
    LEAD: 'lead',
    QR_CONFIRMATION: 'qrConfirmation',
};
